import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ErrorBoundary } from '../components/common/ErrorBoundary';
import { Header } from '../components/layout/Header';

export function EmailVerificationSuccessPage() {
  const navigate = useNavigate();

  // Auto-redirect to login after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50">
        <Header hideSignInButton={true} />
        <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-md w-full space-y-8 text-center">
            <div>
              <div className="flex items-center justify-center mb-4">
                <svg className="h-16 w-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-2">
                Email Verified Successfully!
              </h2>
              <p className="text-gray-600 mb-6">
                Your email has been verified. You can now sign in to your account.
              </p>
              <p className="text-sm text-gray-500 mb-8">
                Redirecting to login page in a few seconds...
              </p>
              <Link
                to="/login"
                className="btn btn-primary"
              >
                Go to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}
